export function KPICard({ label, value, sub, icon: Icon, trend, color = "default" }) {
  const colorClasses = {
    default: "from-white/5 to-white/[0.02] border-white/10",
    green: "from-emerald-500/10 to-emerald-500/[0.02] border-emerald-500/20",
    red: "from-red-500/10 to-red-500/[0.02] border-red-500/20",
    amber: "from-amber-500/10 to-amber-500/[0.02] border-amber-500/20",
    blue: "from-sky-500/10 to-sky-500/[0.02] border-sky-500/20",
  };
  return (
    <div className={`bg-gradient-to-br ${colorClasses[color]} border rounded-xl p-4`}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs uppercase tracking-wider text-white/40 font-medium">{label}</span>
        {Icon && <Icon size={16} className="text-white/20" />}
      </div>
      <div className="text-2xl font-bold text-white tracking-tight">{value}</div>
      {sub && <div className="text-xs text-white/40 mt-1">{sub}</div>}
    </div>
  );
}
